import React, { useState, useEffect } from 'react'

//* Translations
import strings from 'translations/strings.json';

//* Images
import products_images from 'assets/products.json';

//* Products Data
import data from 'data/filo-tag.json';
import prices from 'data/prices'

//* Components
import QuantityCell from './compoents/QuantityCell/QuantityCell';

//* Hooks
import useResponsiveJSX from 'hooks/useResponsiveJSX';

//* Utilities
import { getSubtotal } from './utilities';

//* Styles
import styles from './CartRow.module.scss';
import { removeWcProduct } from 'api/woocommerce';
import { setProductIdBasedOnLang } from '../utilities';

const CartRow = ({productId, quantity, cart, setCart, wcCart}) => {

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]
    const PRODUCT_LANG = setProductIdBasedOnLang(productId)
    const DATA_LANG = data[PRODUCT_LANG]
    const PRODUCTS_IMGS = products_images[PRODUCT_LANG]
    const STINGS_PRODUCT_BY_PRODUCT_LANG = strings[PRODUCT_LANG]

    const [{ subtotal }, setSubtotal] = useState({ subtotal: getSubtotal(prices[DATA_LANG[productId].variation.pack], quantity)})
    const [{ actualQuantity }, setActualQuantity] = useState({ actualQuantity: quantity })


    useEffect(() => {
      
        // Set new actual quantity
        setActualQuantity({ actualQuantity: quantity })
        
    }, [quantity])
    
    useEffect(() => {
        // Set new subtotal
        let newSubtotal = getSubtotal(prices[DATA_LANG[productId].variation.pack], actualQuantity)
        setSubtotal({ subtotal: newSubtotal })
      
    }, [actualQuantity])

    function addProduct(product_id) {
        
        if(cart !== undefined && cart !== null){

            let newCart = { ...cart }
            let newFindProduct = { ...newCart[product_id] }

            let newQuantity = actualQuantity + 1

            setActualQuantity({ actualQuantity: newQuantity})
            newFindProduct.quantity = newQuantity

            newCart[product_id] = newFindProduct

            // console.log("add", newCart)
            // localStorage.setItem("existing_cart", JSON.stringify(newCart))
            setCart(newCart)

        }
        
    }

    function minusProduct(product_id) {

        if(actualQuantity > 1){
            
            if(cart !== undefined && cart !== null){
    
                let newCart = { ...cart }
                let newFindProduct = { ...newCart[product_id] }

                let newQuantity = actualQuantity - 1
    
                setActualQuantity({ actualQuantity: newQuantity})
                newFindProduct.quantity = newQuantity
    
                newCart[product_id] = newFindProduct
    
                // console.log("minus", newCart)
                // localStorage.setItem("existing_cart", JSON.stringify(newCart))
                setCart(newCart)
    
            }
        }
    }

    async function removeProduct(product_id) {

        
        if(cart !== undefined && cart !== null){

            let newExistingCart = { ...cart }

            delete newExistingCart[product_id]

            // console.log("new existing cart",newExistingCart)

            // localStorage.setItem('existing_cart', JSON.stringify(newExistingCart))
            setCart(newExistingCart)

        }
        await removeWcProduct(product_id)

    }

    const bp = useResponsiveJSX()

    if(bp < 2 ){
        return (
            <div className={styles["cart-row"]}>

                <div className={`${styles["cart-cell"]} ${styles["mobile"]} ${styles["product"]}`}>
                    <div className={styles["product-name"]}>
                        <p className={styles["product-label"]}>Filo Tag - Bluetooth Tracker</p>
                        <p className={styles["value"]}>{STINGS_PRODUCT_BY_PRODUCT_LANG[productId]}</p>
                    </div>
                </div>
                <div className={`${styles["cart-cell"]} ${styles["mobile"]} ${styles["product"]}`}>
                    <div className={styles["product-img"]}>
                        <img src={PRODUCTS_IMGS[productId]} alt={`${STRINGS_LANG[productId]}`} />
                    </div>
                </div>
                <div className={`${styles["cart-cell"]} ${styles["mobile"]} ${styles["price"]}`}>
                    <p className={styles["label"]}>{STRINGS_LANG.price}</p>
                    <p className={styles["value"]}>€ {prices[DATA_LANG[productId].variation.pack]}</p>
                </div>
                <div className={`${styles["cart-cell"]} ${styles["mobile"]} ${styles["quantity"]}`}>
                    <p className={styles["label"]}>{STRINGS_LANG.quantity}</p>
                    <QuantityCell
                        quantity={actualQuantity}
                        addProduct={() => addProduct(productId)}
                        removeProduct={() => minusProduct(productId)}
                    />
                </div>
                <div className={`${styles["cart-cell"]} ${styles["mobile"]} ${styles["subtotal"]}`}>
                    <p className={styles["label"]}>{STRINGS_LANG.subtotal}</p>
                    <p className={styles["value"]}>€ {subtotal}</p>
                </div>
                <div className={`${styles["cart-cell"]} ${styles["mobile"]} ${styles["remove"]}`}>
                    <button className={`${styles["btn"]} ${styles["remove-btn"]}`}
                        onClick={() => removeProduct(productId)}
                    >
                        { STRINGS_LANG.remove }
                    </button>
                </div>
            </div>
        )
    }

  return (
    <div className={styles["cart-row"]}>
        <div className={`${styles["cart-cell"]} ${styles["product"]}`}>
            <div className={styles["product-img"]}>
                <img src={PRODUCTS_IMGS[productId]} alt={`${STRINGS_LANG[productId]}`} />
            </div>
            <div className={styles["product-name"]}>
                <p className={styles["product-label"]}>Filo Tag - Bluetooth Tracker</p>
                <p className={styles["value"]}>{STINGS_PRODUCT_BY_PRODUCT_LANG[productId]}</p>
            </div>
        </div>
        <div className={`${styles["cart-cell"]} ${styles["price"]}`}>
            <p className={styles["value"]}>€ {prices[DATA_LANG[productId].variation.pack]}</p>
        </div>
        <div className={`${styles["cart-cell"]} ${styles["quantity"]}`}>
            <QuantityCell
                quantity={actualQuantity}
                addProduct={() => addProduct(productId)}
                removeProduct={() => minusProduct(productId)}
            />
        </div>
        <div className={`${styles["cart-cell"]} ${styles["subtotal"]}`}>
            <p className={styles["value"]}>€ {subtotal}</p>
        </div>
        <div className={`${styles["cart-cell"]} ${styles["remove"]}`}>
            <ion-icon name="close-circle"
                onClick={() => removeProduct(productId)}
            ></ion-icon>
        </div>
    </div>
  )
}

export default CartRow